import React, { useContext, useCallback, useMemo } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { EntityUtil } from '@xengage/gw-portals-util-js';
import { withRouter } from 'react-router-dom';
import styles from '../envImpairment.module.scss';
import metadata from './StorageTanksComponent.metadata.json5';
import './StorageTanksComponent.messages';
import StorageTanksInformationComponent from "../subcomponents/StorageTanksInformation/StorageTanksInformationComponent"

function StorageTanksComponent(props) {
    const { submissionVM, pathUpdated, updateWizardData } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('StorageTanksComponent');
    const viewModelService = useContext(ViewModelServiceContext);
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true

    const addStorageTankInformation = useCallback(async () => {

        const storageTanksinformationObj = {
            tempID: EntityUtil.nextId()
        };

        const { _xCenter, _dtoName } = submissionVM.lobData.envLin.coverables.envImpairmentCoverable.storageTanks.storageTanksInformation;

        const storageTankInformationVM = viewModelService.create(storageTanksinformationObj, _xCenter, _dtoName);

        submissionVM.lobData.envLin.coverables.envImpairmentCoverable.storageTanks.storageTanksInformation.value = submissionVM.lobData.envLin.coverables.envImpairmentCoverable.storageTanks.storageTanksInformation.value || []


        submissionVM.lobData.envLin.coverables.envImpairmentCoverable.storageTanks.storageTanksInformation.pushElement(
            storageTankInformationVM
        );
        updateWizardData(submissionVM);
    },
        [submissionVM, viewModelService, updateWizardData]
    );

    const informationOverrides = useMemo(() => {
        const informationList = _.get(submissionVM, 'lobData.envLin.coverables.envImpairmentCoverable.storageTanks.storageTanksInformation', []);
        let overrides = '';

        if (!_.isEmpty(informationList)) {
            overrides = informationList?.children.map((information, index) => ({
                [`storageTanksInformationComponent${index}`]: {
                    overrideProps: {
                        "@field": {
                            // apply to all fields
                            showRequired: true,
                            labelPosition: "left",
                        },
                    },
                    submissionVM,
                    updateWizardData,
                    StorageTanksInformationPath: `lobData.envLin.coverables.envImpairmentCoverable.storageTanks.storageTanksInformation.children[${index}]`,
                    informationVm: information,
                    index,
                    viewModelService
                }
            }));
        }

        return Object.assign({}, ...overrides);
    }, [updateWizardData, submissionVM]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        ...informationOverrides,
    };

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            addStorageTankInformation
        },
        resolveComponentMap: {
            storageTanksInformationComponent: StorageTanksInformationComponent
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );


    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );

}

StorageTanksComponent.propTypes = wizardProps;
export default withRouter(StorageTanksComponent);
